import { ApiErrorHandlingOutcome, ParsedApiError } from "@jugl-web/rest-api";
import { createContext } from "react";

export interface ApiResultHandlingConfig {
  /**
   * App-level routing for product-wide errors (paywalls, write-restricted,
   * 403 policy, ...). Runs only when the call site didn't handle the error;
   * return "unhandled" to fall through to the default toast.
   */
  onSpecialError?: (error: ParsedApiError) => ApiErrorHandlingOutcome;
  /** Observability tap — called once for every error that goes through the pipeline. */
  onErrorReported?: (error: ParsedApiError) => void;
}

// The default value is usable on purpose: useApiResultHandler works without a
// mounted provider; apps mount ApiResultHandlingProvider to add app-specific
// behavior and the global pipeline.
export const ApiResultHandlingContext = createContext<ApiResultHandlingConfig>(
  {}
);
